  
import {useContext } from 'react';

 
import OnboardingCompleted from './OnboardingCompleted';
import OnboardingStarted from './OnboardingStarted';
import {UserContext} from '../../../contexts/UserContext/UserContext';
import {ApplicantRoleData} from '../../../types/User';

export default function ApplicantOnboardingPage() {
  const {currentUser} = useContext(UserContext);
  const onboardingComplete =
    currentUser?.role.data && (currentUser?.role.data as ApplicantRoleData).onboardingCompleted;

  return onboardingComplete ? <OnboardingCompleted /> : <OnboardingStarted firstName={currentUser?.firstName} />;
}
